export const FETCH_PASSENGERS = 'FETCH_PASSENGERS'

export default (flightId: string) => ({
  type: FETCH_PASSENGERS,
  flightId,
})
